import { FC, useContext } from 'react';
import { InfoDrawerContext } from '../../providers/InfoDrawer';
import { IInfoDrawerValues } from '../../constants/infoDrawerValues';
import styles from './InfoButton.module.scss';

interface IInfoButtonProps {
  /** Chiave della guida in INFO_DRAWER_VALUES (es. 'acwr', 'ri', 'srpe'). */
  infoKey: keyof IInfoDrawerValues;
  /** Testo accessibile (aria-label/title); default generico. */
  label?: string;
}

/**
 * Bottone «?» che apre la guida di dominio nell'InfoDrawer condiviso
 * (feature #16). Sostituisce l'`.helpBtn` inline duplicato in AFITab: un solo
 * componente accessibile (button reale + aria-label), token tema, da mettere
 * accanto a metriche/legende/KPI gergali.
 */
const InfoButton: FC<IInfoButtonProps> = ({ infoKey, label }) => {
  const { setState } = useContext(InfoDrawerContext);
  const text = label ?? 'Cosa significa?';

  return (
    <button
      type="button"
      className={styles.btn}
      onClick={() => setState(infoKey)}
      aria-label={text}
      title={text}
    >
      ?
    </button>
  );
};

export default InfoButton;
